// #region Dependencias
import styled from 'styled-components'
import { InputImagePreview } from 'components/Library'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledSection = styled.section`
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  display: flex;
  justify-content: center;
`

const StyledH1 = styled.h1`
  align-items: center;
  color: ${colors.white};
  display: flex;
  justify-content: center;
  margin: 0;
  position: absolute;
  text-align: center;

  ${({ contentEditable }) =>
    contentEditable &&
    `
    &:hover {
      box-shadow: 0px 0px 0px 2px ${colors.secondary};
    }

    &:focus-visible {
      box-shadow: 0px 0px 0px 2px ${colors.secondary};
      outline: none;
    }
  `}
`
// #endregion

/**
 * Componente para renderizar la sección Hero de la página.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {boolean} props.contentEditable - Valor que indica si los elementos son editables.
 * @param {Function} props.handleInputChange - Callback para actualizar los valores de los elementos del componente.
 * @param {string} props.src - Atributo 'src' de la imagen del componente.
 * @param {string} props.alt - Atributo 'alt' de la imagen del componente.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const Hero = ({ idioma, contentEditable, handleInputChange, src, alt, children }) => {
  return (
    <StyledSection id="hero">
      <InputImagePreview
        name={`secciones.hero.${idioma}.imagen`}
        modoEdicion={contentEditable}
        onChange={handleInputChange}
        alt={alt}
        src={src}
        style={{
          width: '100%'
        }}
      />
      <StyledH1
        contentEditable={contentEditable}
        suppressContentEditableWarning={true}
        data-id={`secciones.hero.${idioma}.texto`}
        onBlur={handleInputChange}
      >
        {children}
      </StyledH1>
    </StyledSection>
  )
}

export default Hero
